export default {
	'health-certificates': 'Health certificates',
    'health-certificate': 'health certificate',
    'add-a-health-certificate': 'add a health certificate'
}